module.exports = __webpack_public_path__ + "img/card-5-7~10.3a700ea9.svg";